module.exports = __webpack_public_path__ + "img/warmup_back.7ce238be.jpg";